import { render } from "./CadastroArtEngenheiroTransportadorRequest.vue?vue&type=template&id=65da5ab4"
import script from "./CadastroArtEngenheiroTransportadorRequest.vue?vue&type=script&lang=ts"
export * from "./CadastroArtEngenheiroTransportadorRequest.vue?vue&type=script&lang=ts"
script.render = render

export default script